import { MuiTypography } from '@/features/shared/material-ui';
import RichText from '@/features/shared/RichText';
import { Theme } from '@/utils/constants';
import React from 'react';
import { CSwitch } from '../CSwitch';
import { ToggleOptionProps } from './ToggleOption.interface';
import useStyles from './ToggleOption.styles';

const ToggleOption = (props: ToggleOptionProps) => {
  const classes = useStyles({});
  const label = React.useMemo(
    () => ({ inputProps: { 'aria-label': props?.label } }),
    [props?.label],
  );
  const { register, watch } = props.form;
  const controlProps = React.useMemo(
    () => register(props.marketoName),
    [props.marketoName, register],
  );
  const isChecked = React.useMemo(
    () => watch(props.marketoName)?.includes(props.value),
    [props.marketoName, props.value, watch],
  );

  return (
    <div className={classes.root}>
      <CSwitch value={props.value} {...label} {...controlProps} defaultChecked={isChecked} />

      {(!!props?.label || !!props?.description) && (
        <div>
          {!!props?.label && (
            <MuiTypography component="h5" variant="body1">
              <strong>{props?.label}</strong>
            </MuiTypography>
          )}
          {!!props?.description && (
            <RichText
              className={classes.description}
              theme={Theme.dark}
              content={props.description}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ToggleOption);
